<template>
  <!-- mob -->
  <div  class="threepage">
    <img  src="/assets/~/media/images/activity/film2505-prod/mob/6.jpg" alt="" />
    <div
      ref="slideCarousel"
      class="carousel-container"
      style="overflow: hidden"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          style="height: 100%"
          v-for="item in imgUrls"
          :key="item.index"
        >
          <img style="opacity: 1; width: 100%" :src="preText + item.urlmb" code-stm="event, PAGEURL页面, 他说" />
        </div>
      </div>
    </div>
    <div class="swiper-pagination-kv2"></div>
  </div>

</template>

<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
import Swiper from "swiper";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText: "https://www.kia.cn",
      imgUrls: [
        {
          index: 0,
          urlmb: "/assets/~/media/images/activity/film2505-prod/mob/ta-1.png",
        },
        {
          index: 1,
          urlmb: "/assets/~/media/images/activity/film2505-prod/mob/ta-2.png",
        },
        {
          index: 2,
          urlmb: "/assets/~/media/images/activity/film2505-prod/mob/ta-3.png",
        },
      ],
    };
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true;
      } else {
        return false;
      } //判断是否Safari浏览器
    },
  },
  watch: {},
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    // this.slideBanner()
    window.addEventListener("resize", this.setResize);

    this.$nextTick(() => {
      this.swiper = new Swiper(".carousel-container", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // sliderPerview: 'auto',
        // loopAdditionalSlides: 5,
        // loopFillGroupWithBlank: false,
        // autoplayDisableOnInteraction: false,

        autoplay: {
            delay: 5000,
             disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination-kv2",
        },
        // navigation: {
        //   nextEl: "#swiper-button-next",
        //   prevEl: "#swiper-button-prev",
        // },
        on: {
          slideChangeTransitionEnd: this.slideChangeTransitionEnd,
        },
      });
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.setResize);
  },
  methods: {
    //了解更多
    learnMore() {
      window.open(
        "https://www.kia.cn/brand/news/official-news/2023122901/2024111502/"
      );
    },
    // 滑动切换
    slideBanner() {
      console.log("滑动切换");
      //选中的轮播图
      var box = document.querySelector(".el-carousel__container");
      box.onClick = () => {
        console.log("点击el-carousel");
      };
      var startPointX = 0;
      var stopPointX = 0;
      //重置坐标
      var resetPoint = function () {
        startPointX = 0;
        stopPointX = 0;
      };
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPointX = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPointX = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this;
      box.addEventListener("touchend", function (e) {
        if (stopPointX == 0 || startPointX - stopPointX == 0) {
          console.log("a");
          resetPoint();
          return;
        }
        if (startPointX - stopPointX > 0) {
          resetPoint();
          that.$refs.slideCarousel.next();
          console.log("b");
          return;
        }
        if (startPointX - stopPointX < 0) {
          resetPoint();
          that.$refs.slideCarousel.prev();
          console.log("c");
          return;
        }
      });
    },
    toev5() {
      window.open("https://www.kia.cn/vehicles/ev6/");
    },

    slideChangeTransitionEnd() {
      //   this.playVideo(this.swiper?.activeIndex);
      //   this.pauseVideo(this.swiper?.previousIndex);
    },
    setResize() {
      this.isPortrait = isPortraitFun();
    },
  },
};
</script>
<style lang="scss" scoped>

//mob strat
@media (max-width: 767px) {
  .swiper-pagination-kv2 {
    // top: calc(50% - 210 / 1920 * 100vw + 551 / 1920 * 100vw);
    // left: calc(100% - 964 / 1920 * 100vw - 140 / 1920 * 100vw);
    width: 100%;
  }
  .swiper-pagination-bullets {
    bottom: calc(38 / 375 * 100vw);
    position: absolute;
    display: flex;
    justify-content: end;
    align-items: center;
    width: calc((279 + 48) / 375 * 100vw);
    padding-left: calc(48 / 375 * 100vw);
    z-index: 100;
    // padding-top: calc(14 / 375 * 100vw);
  }
  ::v-deep .swiper-pagination-bullet {
    margin: calc(7 / 375 * 100vw) calc(4 / 375 * 100vw);
    background: rgba(217, 217, 217, 1);
    border: none;
    width: calc(10 / 375 * 100vw);
    height: calc(10 / 375 * 100vw);
  }
  ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #fff;
    border-radius: 10px;
    width: calc(10 / 375 * 100vw);
    height: calc(10 / 375 * 100vw);
  }
  .threepage {
    position: relative;
    width: 100%;
    height: calc(661 / 375 * 100vw);
    user-select: none;
    // padding-top: calc(156 / 375 * 100vw);
    background-color: lightblue;
    img {
        @media (max-width:767px) {
            margin-bottom: -1px;
        }

        width: 100%;
    }
  }

  .carousel-container {
    position: absolute;
    top: calc(156 / 375 * 100vw);
    left: calc(48 / 375 * 100vw);
    width: calc(279 / 375 * 100vw);
    height: calc(456 / 375 * 100vw);
    margin: auto;

    // padding-bottom: calc(50 / 375 * 100vw );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // border-radius: calc(15 / 375 * 100vw);
    background-color: transparent;
  }
  ::v-deep .swiper-slide-active {
     background-color: transparent;
  }
  .swiper-wrapper {
    background-color: transparent;
  }
}

@media screen and (orientation: portrait) {
  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }
  .swiper-pagination-kv2 {
    // bottom: 20px !important;
  }
}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 0;
}

//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: #ffffff;

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: #475669;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.swiper {
  width: 100%;
  height: 400px;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  // background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

// .swiper-slide img {
//   display: block;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }
// .swiper-pagination-kv2 {
//   position: absolute;
//   bottom: 70px;
//   left: 0;
//   width: 100%;
//   text-align: center;
//   z-index: 10;
// }
</style>
